var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, withStyles } from '@material-ui/core';
import NumberInputCss from './css/NumberInputCss';
var NumberInput = (_temp2 = _class = function (_Component) {
  _inherits(NumberInput, _Component);

  function NumberInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, NumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  NumberInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var newState = _extends({}, prevState);

    if (nextProps.name && nextProps.value !== prevState[nextProps.name]) {
      var _extends2;

      newState = _extends({}, newState, (_extends2 = {}, _extends2[nextProps.name] = nextProps.value, _extends2.formatted = NumberInput.formatNumber(nextProps.value), _extends2));
    }

    return newState;
  };

  NumberInput.formatNumber = function formatNumber(number) {
    return !!number ? number.toString().replace('.', ',') : number;
  };

  NumberInput.flattenNumber = function flattenNumber(number) {
    return !!number ? number.toString().replace(',', '.') : number;
  };

  NumberInput.prototype.getErrorMessage = function getErrorMessage(name) {
    var collectionStore = this.props.collectionStore;

    if (collectionStore.errors && collectionStore.errors[name]) {
      return collectionStore.errors[name].map(function (err, index) {
        return React.createElement('span', {
          style: {
            display: 'block'
          },
          key: index
        }, err);
      });
    } else {
      return null;
    }
  };

  NumberInput.prototype.onChangeHandler = function onChangeHandler(name, event) {
    var _setState;

    var formatted = NumberInput.formatNumber(event.target.value);
    var flat = NumberInput.flattenNumber(event.target.value);
    this.setState((_setState = {}, _setState[name] = flat, _setState.formatted = formatted, _setState));
    var dummy = {
      target: {
        value: flat
      }
    };
    this.props.onChangeHandler(name, dummy);
  };

  NumberInput.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        collectionStore = _props.collectionStore,
        name = _props.name,
        value = _props.value;
    var formatted = this.state.formatted;
    var filteredProps = ['name', 'collectionStore', 'onChangeHandler', 'value', 'dispatch', 'decimalDigits', 'decimalSeparator', 'thousandsSeparator'];
    var inputProps = Object.keys(this.props).filter(function (k) {
      return !filteredProps.includes(k);
    }).reduce(function (obj, key) {
      obj[key] = _this2.props[key];
      return obj;
    }, {});
    var error = !!collectionStore.errors && !!collectionStore.errors[name];
    return React.createElement(TextField, _extends({
      error: error,
      helperText: this.getErrorMessage(name),
      value: value ? formatted : '',
      onChange: this.onChangeHandler.bind(this, name)
    }, inputProps, {
      theme: {}
    }), this.props.children);
  };

  return NumberInput;
}(Component), _class.defaultProps = {
  decimalDigits: 0,
  decimalSeparator: ',',
  thousandsSeparator: ' '
}, _temp2);
NumberInput.propTypes = process.env.NODE_ENV !== "production" ? {
  decimalDigits: PropTypes.number,
  decimalSeparator: PropTypes.string,
  thousandsSeparator: PropTypes.string
} : {};
export default withStyles(NumberInputCss)(NumberInput);